import { render, staticRenderFns } from "./ServiceSideBarItem.vue?vue&type=template&id=9d8670ac&"
import script from "./ServiceSideBarItem.vue?vue&type=script&lang=js&"
export * from "./ServiceSideBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d8670ac')) {
      api.createRecord('9d8670ac', component.options)
    } else {
      api.reload('9d8670ac', component.options)
    }
    module.hot.accept("./ServiceSideBarItem.vue?vue&type=template&id=9d8670ac&", function () {
      api.rerender('9d8670ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ServiceSideBarItem.vue"
export default component.exports